import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 123.8-90.7 226.4-209.3 245v-173.3h57.8l11-71.7h-68.8v-46.5c0-19.6 9.6-38.7 40.4-38.7h31.3v-61s-28.4-4.8-55.5-4.8c-56.7 0-93.7 34.3-93.7 96.5v54.6h-63v71.7h63v173.3c-118.6-18.6-209.3-121.2-209.3-245 0-137 111-248 248-248s248 111 248 248z'
      }
    ]
  }
})
